import React, { useMemo } from 'react';
import { getAnswerColorTheme } from '../../utils';
import { cn } from '../ui/utils';

const colorClassMap = {
  green: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  orange: 'border-amber-200 bg-amber-50 text-amber-800',
  red: 'border-rose-200 bg-rose-50 text-rose-800',
  gray: 'border-border bg-muted/50 text-muted-foreground'
};

export const QuestionResultTag = ({ answerStatus, score, maxScore, className }) => {
  const { color, text } = useMemo(() => getAnswerColorTheme(answerStatus), [answerStatus]);
  const hasScore = maxScore != null && maxScore !== '';

  return (
    <div
      className={cn(
        'inline-flex max-w-full flex-col rounded-xl border px-4 py-3 text-center text-sm font-medium leading-snug',
        colorClassMap[color] ?? colorClassMap.gray,
        className
      )}
    >
      <span>{text}</span>
      {hasScore ? (
        <span className="mt-1 text-xs font-semibold tabular-nums">
          Score {score ?? 0} / {maxScore}
        </span>
      ) : null}
    </div>
  );
};
